import { useState, useEffect, useCallback, useRef } from 'react';

export function useCardCompanyUI({ onClose }) {
  const [swipeStart, setSwipeStart] = useState(0);
  const [swipeDistance, setSwipeDistance] = useState(0);
  const [isSwipeActive, setIsSwipeActive] = useState(false);
  const [isGrabHandleVisible, setIsGrabHandleVisible] = useState(true);
  
  const contentRef = useRef(null);
  const lastScrollTop = useRef(0);
  const swipeAreaRef = useRef(null);

  // Manejar scroll para mostrar/ocultar el grab handle
  const handleScroll = useCallback(() => {
    if (!contentRef.current) return;

    const currentScrollTop = contentRef.current.scrollTop;
    const isScrollingUp = currentScrollTop < lastScrollTop.current;
    const isCurrentlyAtTop = currentScrollTop === 0;

    if (isCurrentlyAtTop) {
      setIsGrabHandleVisible(true);
    } else if (isScrollingUp) {
      setIsGrabHandleVisible(true);
    } else {
      setIsGrabHandleVisible(false);
    }

    lastScrollTop.current = currentScrollTop;
  }, []);

  // Setup y cleanup de event listeners
  useEffect(() => {
    const contentElement = contentRef.current;
    if (contentElement) {
      contentElement.addEventListener("scroll", handleScroll, {
        passive: true,
      });
    }

    return () => {
      if (contentElement) {
        contentElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll]);

  // Handlers para gestos touch
  const handleTouchStart = useCallback((e) => {
    if (swipeAreaRef.current?.contains(e.target)) {
      setSwipeStart(e.touches[0].clientY);
      setIsSwipeActive(true);
    }
  }, []);

  const handleTouchMove = useCallback((e) => {
    if (!isSwipeActive) return;
    const currentY = e.touches[0].clientY;
    const distance = currentY - swipeStart;
    if (distance > 0) {
      setSwipeDistance(distance);
      e.preventDefault();
    }
  }, [isSwipeActive, swipeStart]);

  const handleTouchEnd = useCallback(() => {
    if (swipeDistance > 240) {
      onClose();
    }
    setSwipeDistance(0);
    setIsSwipeActive(false);
  }, [swipeDistance, onClose]);

  // Utilidad para abrir links
  const handleLinkClick = useCallback((url) => {
    window.open(url, "_blank");
  }, []);

  // Utilidad para determinar tamaño de video preview
  const getVideoPreviewSize = useCallback((size) => {
    return size === "Desktop 1440" ? "Desktop 1200" : size;
  }, []);

  return {
    // Referencias
    contentRef,
    swipeAreaRef,
    
    // Estados
    swipeDistance,
    isSwipeActive,
    isGrabHandleVisible,
    
    // Handlers
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd,
    handleLinkClick,
    
    // Utilidades
    getVideoPreviewSize
  };
}